import {immerable} from 'immer';
import Entity from '../entity/Entity';
import Location from '../location/Location';
import Address from '../address/Address';

/**
 * Towing entity type definition
 *
 * @typedef {Object} Towing
 * @property {?Location} location
 * @property {?Address} address
 * @property {?string} destinationName
 * @property {?string} destinationType
 * @property {?boolean} isInsideVpPolygon
 */

/**
 * Towing entity-to-DTO mapping
 *
 * @type {Object<string, EntityDTOProperty>}
 */
const towingEntityDTOMapping = {
    location: {
        dtoProperty: 'location',
        defaultValue: new Location(),
        entity: Location,
    },
    address: {
        dtoProperty: 'address',
        defaultValue: new Address(),
        entity: Address,
    },
    destinationName: {
        dtoProperty: 'destinationName',
        defaultValue: '',
    },
    destinationType: {
        dtoProperty: 'destinationType',
        defaultValue: '',
    },
    isInsideVpPolygon: {
        dtoProperty: 'isInsideVpPolygon',
        defaultValue: false,
    },
};

/**
 * Towing entity
 *
 * @class
 * @extends Entity
 * @type {Towing}
 */
export default class Towing extends Entity {
    [immerable] = true;

    static entityDTOMapping = towingEntityDTOMapping;

    /**
     * @constructor
     * @param rawObject
     */
    constructor(rawObject = {}) {
        super();
        this.initialize(rawObject);
    }
}
